// extracted by css-extract-rspack-plugin
export default {"card":"card-X9Hd7J","outlined":"outlined-kOT4zl","elevation":"elevation-rLJxxM","cardContent":"cardContent-cFe4Bj","cardActions":"cardActions-SDyGxT"};